<template>
  <div
    class="columns is-relative"
    @click="onItemClick"
    :data-id="item.id"
    :data-e2e="SpotlightCypressAttribute.views.GROUP_ITEM"
  >
    <div class="column is-flex-centered is-1 m-l--3">
      <slot name="preview">
        <i class="icon is-size-2 cls has-text-primary" :class="`cls-${item.typeEnum.icon}`" />
      </slot>
    </div>
    <div class="column is-10 m-l--5 px-2">
      <p class="title is-size-5 has-text-weight-semibold">
        <TooltipView type="is-dark" :label="`${item.id}`" :delay="750">
          <slot name="title">
            {{ item.name }}
          </slot>
        </TooltipView>
      </p>
      <div class="subtitle is-size-6 is-flex m-t--15">
        <slot name="enum">
          <Status
            size="is-size-7"
            :color="item.typeEnum.color"
            :text="item.typeEnum.value"
            class="m-t--2 m-r-5 m-l--2"
          />
        </slot>
        <slot name="subtitle" />
        <span class="is-inline-block m-l-3 m-r-3">•</span>
        <span>
          <TooltipView type="is-dark" :label="$t('Last updated')" :delay="250">
            {{ item.timeAgoUpdatedAt }}
          </TooltipView>
        </span>
        <div class="actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import Status from '@/modules/core/app/components/Status.vue';
import { SpotlightCypressAttribute } from '@/modules/spotlight/constants/SpotlightCypressAttribute';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightGroupItem',
  emits: ['on-item-click'],
  slotsDefinition: {
    preview: {},
    title: {},
    enum: {},
    subtitle: {},
    actions: {}
  },
  components: { TooltipView, Status },
  props: {
    item: BaseModel
  },
  static: {
    SpotlightCypressAttribute
  },
  methods: {
    onItemClick() {
      this.$emit('on-item-click');
    }
  }
};
</script>

<style scoped>
.actions {
  position: absolute;
  right: var(--ce-20px);
  top: var(--ce-16px);
}
</style>
